<template>
  <V5Shell
    v-if="ready"
    :page="host.state.page"
    :title="host.state.title"
    :classic="host.state.classic"
    :rail="host.state.rail"
  >
    <router-view />
  </V5Shell>
  <!-- Outside the audience or onboarding: the page's V5Layout redirects and renders nothing -->
  <router-view v-else />
</template>

<script setup>
import { provide } from 'vue';
import V5Shell from './V5Shell.vue';
import { V5_PAGE, createPageHost, useV5Gate } from '../shellPage';

// The parent route of every v5 page in the shell: the shell mounts once, so its loads and
// channels run once per session and a navigation only swaps the page inside it.
const host = createPageHost();
provide(V5_PAGE, host);
const { ready } = useV5Gate();
</script>
